var _style, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResetPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 384 384",
    style: {
      enableBackground: "new 0 0 384 384"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#787878;stroke-width:20;stroke-linecap:round;}\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 150.7,
    y1: 249,
    x2: 150.7,
    y2: 301.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 172.5,
    y1: 260.6,
    x2: 128.9,
    y2: 289.7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 172.8,
    y1: 289.2,
    x2: 128.6,
    y2: 261.1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 235.3,
    y1: 249,
    x2: 235.3,
    y2: 301.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 257.1,
    y1: 260.6,
    x2: 213.6,
    y2: 289.7
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 257.4,
    y1: 289.2,
    x2: 213.3,
    y2: 261.1
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 320,
    y1: 249,
    x2: 320,
    y2: 301.3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 341.8,
    y1: 260.6,
    x2: 298.2,
    y2: 289.7
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 342.1,
    y1: 289.2,
    x2: 297.9,
    y2: 261.1
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 64,
    y1: 249,
    x2: 64,
    y2: 301.3
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 85.8,
    y1: 260.6,
    x2: 42.2,
    y2: 289.7
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 86.1,
    y1: 289.2,
    x2: 41.9,
    y2: 261.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M375.6,330.9H8.4c-0.3,0-0.6-0.3-0.6-0.6V218.7c0-0.3,0.3-0.6,0.6-0.6h367.1c0.3,0,0.6,0.3,0.6,0.6v111.5 C376.2,330.6,375.9,330.9,375.6,330.9z M64,330.9v44.5c0,0.3,0.3,0.6,0.6,0.6h254.8c0.3,0,0.6-0.3,0.6-0.6v-44.5 M320,218.1v-51.6 c0-0.3-0.3-0.6-0.6-0.6H64.6c-0.3,0-0.6,0.3-0.6,0.6v51.6 M259.5,165.9c0,0,0-53.4,0-64s-5.1-64.2-67.4-64.2s-68.3,57.4-68.3,66.1 s0,62.1,0,62.1 M289.5,165.9c0,0,0-44.4,0-66.4S277.3,8,192.3,8s-98.6,68.1-98.6,93.8s0,64.1,0,64.1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPassword);
export default __webpack_public_path__ + "static/media/reset-password.cbf1160d35240393622de91718f71920.svg";
export { ForwardRef as ReactComponent };